import React, { useState } from 'react';
import {
  ToggleButton,
  Button,
  Collapse,
  List,
  ListItem,
  FormControl,
  ListItemIcon,
  TextField,
  CardActions,
  Stack,
  ListItemText,
  Box,
  Card,
  Alert,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
  Link,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import LoadingButton from '../../@iosper/components/LoadingButton';
import { findFarmacias } from '../../services/Busquedas/Farmacias';
import {
  HighlightOff,
  Search,
  KeyboardArrowDown,
  KeyboardArrowUp,
  FmdGood,
  LocalPhone,
  Email,
  AccessTime,
} from '@mui/icons-material';
import CustomizedSnackbars from '../Notifications/SnackBar';
import { useWidth } from '../../@iosper/utils/UseWidth';
import LocalidadAutocomplete from '../Common/LocalidadAutocomplete';
import { useForm } from 'react-hook-form';
import ButtonBack from '../Breadcrumb/ButtonBack';
import { VideoModal } from '../Common/VideoModal';

const BuscarFarmacias = () => {
  const [loading, setLoading] = useState(false);
  const [alertResultFind, setAlertResultFind] = useState('');
  const [error, setError] = useState('');
  const [visibleInfo, setVisibleInfo] = useState(false);
  const [farmacias, setFarmacias] = useState([]);
  const [visibleFind, setVisibleFind] = useState(true);
  const screenWidth = useWidth();
  const [selectedLocalidad, setSelectedLocalidad] = useState(null);
  const [keyComponentLocalidad, setKeyComponentLocalidad] = useState(0);

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });

  const DataCollapseDrawer = (props) => {
    const { farmacia } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <Box sx={{ width: '100%' }}>
        <ToggleButton
          aria-label='expand row'
          value='check'
          onChange={() => {
            setOpen(!open);
          }}
          sx={{ border: 0, p: 0 }}
          fullWidth={true}
        >
          <Grid
            container
            direction='row'
            justifyContent='flex-start'
            alignItems='center'
            gap={2}
            flexWrap='nowrap'
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            <Typography
              variant='body1'
              align='left'
              gutterBottom={false}
              sx={{ color: '#000', textTransform: 'none' }}
            >
              {`${farmacia?.nombre || ''} ( ${farmacia?.localidad || ''} )`}
            </Typography>
          </Grid>
        </ToggleButton>

        <Collapse in={open} timeout='auto' unmountOnExit>
          <Box sx={{ margin: 1 }}>
            <List sx={{ py: 0 }}>
              {farmacia?.direccion && (
                <ListItem
                  component='a'
                  href={`https://www.google.com/maps/search/${encodeURIComponent(
                    farmacia?.domicilio + ', ' + farmacia?.localidad,
                  )}`}
                  sx={{ py: 1 }}
                >
                  <ListItemIcon sx={{ color: 'secondary.main' }}>
                    <FmdGood />
                  </ListItemIcon>
                  <ListItemText
                    sx={{ margin: -3 }}
                    primary={
                      <Typography
                        variant='body2'
                        sx={{ color: 'primary.dark', textDecoration: 'underline' }}
                      >
                        {`${farmacia?.direccion || ''}`}
                      </Typography>
                    }
                  />
                </ListItem>
              )}
              {farmacia?.telefono && (
                <ListItem component='a' href={`tel:${farmacia?.telefono || ''}`} sx={{ py: 0 }}>
                  <ListItemIcon sx={{ color: 'secondary.main' }}>
                    <LocalPhone />
                  </ListItemIcon>
                  <ListItemText
                    sx={{ margin: -3 }}
                    primary={
                      <Typography
                        variant='body2'
                        sx={{ color: 'primary.dark', textDecoration: 'underline' }}
                      >
                        {`${farmacia?.telefono || ''}`}
                      </Typography>
                    }
                  />
                </ListItem>
              )}
              {farmacia?.mail && (
                <ListItem component='a' href={`mailto:${farmacia?.mail || ''}`} sx={{ py: 0 }}>
                  <ListItemIcon sx={{ color: 'secondary.main' }}>
                    <Email />
                  </ListItemIcon>
                  <ListItemText
                    sx={{ margin: -3 }}
                    primary={
                      <Typography
                        variant='body2'
                        sx={{ color: 'primary.dark', textDecoration: 'underline' }}
                      >
                        {`${farmacia?.mail || ''}`}
                      </Typography>
                    }
                  />
                </ListItem>
              )}
            </List>
          </Box>
        </Collapse>
      </Box>
    );
  };

  /// -------------------- DATA GRID FARMACIA --------------------------
  const mapFarmaciaToRow = (p) => ({
    id: p.idFarmacia,
    nombre: p.nombre,
    localidad: p.localidad,
    direccion: p.direccion,
    telefono: p.telefono,
    mail: p.mail,
  });

  const columns = [
    {
      field: 'desplegable',
      headerName: 'Farmacias',
      flex: 1,
      renderCell: (a) => <DataCollapseDrawer farmacia={a.row} />,
    },
    { field: 'nombre', headerName: 'Nombre', width: 220 },
    { field: 'localidad', headerName: 'Localidad', width: 220 },
    { field: 'direccion', headerName: 'Domicilio', width: 140 },
    { field: 'mail', headerName: 'Correo electrónico', flex: 0.1 },
    { field: 'telefono', headerName: 'Teléfono', flex: 0.1 },
  ];

  const find = async (data, e) => {
    e.preventDefault();
    setLoading(true);
    setVisibleInfo(false);
    setAlertResultFind('');
    setError('');

    if (data.nombre === '' && selectedLocalidad === null) {
      setError('Debes ingresar por lo menos un criterio para realizar la búsqueda');
      setLoading(false);
    } else {
      const result = await findFarmacias({
        nombre: data.nombre,
        idLocalidad: selectedLocalidad?.localidadVO.idLocalidad,
      });

      if (result && result.length > 0) {
        if (result.length >= 50) {
          setVisibleInfo(true);
        }
        setFarmacias(result);
        setVisibleFind(false);
      } else {
        setAlertResultFind('No se han encontrado farmacias');
      }
      setLoading(false);
    }
  };

  const handlerLimpiar = () => {
    setKeyComponentLocalidad(1 + Math.random() * (1000 - 1));
    setSelectedLocalidad(null);
    reset();
  };

  const handleBuscarOtra = () => {
    setFarmacias([]);
    setVisibleFind(true);
    setVisibleInfo(false);
    handlerLimpiar();
  };

  const handlerSelectLocalidad = (localidad) => {
    setSelectedLocalidad(localidad);
  };

  const handleBorrarMensaje = () => {
    setError('');
    setAlertResultFind('');
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ButtonBack marginBotton='1' variant='text' size='small'></ButtonBack>
        <Card sx={{ width: '100%', p: 1 }}>
          <CardContent>
            <Typography
              tabIndex={0}
              aria-label='Buscar Farmacias'
              gutterBottom
              variant='h5'
              component='h2'
            >
              Buscar Farmacias
            </Typography>
            <Typography variant='string' component={'div'}>
              Acá podrás consultar las farmacias, ingresando alguno de los siguientes criterios de
              búsqueda.
            </Typography>
            {/* <VideoModal
              sx={{ pt: 2 }}
              src={'https://www.youtube.com/embed/vwYdb8axV7o?si=Iaa0quv05vrjVnzq&autoplay=1'}
            /> */}
          </CardContent>
          {visibleFind && (
            <form>
              <CardContent>
                <FormControl fullWidth={true} variant='outlined'>
                  <TextField
                    variant='standard'
                    type='text'
                    fullWidth
                    margin='normal'
                    name='nombre'
                    label='Nombre'
                    {...register('nombre', {
                      maxLength: {
                        value: 200,
                        message: 'El campo nombre es demasiado largo',
                      },
                      pattern: {
                        value: /^(([a-zñA-ZÑ. ]{1,60}))$/,
                        message: 'El campo nombre debe contener solo letras',
                      },
                    })}
                  />
                  {errors['nombre'] && <p style={{ color: 'red' }}>{errors['nombre'].message}</p>}
                </FormControl>
                <FormControl fullWidth={true} variant='outlined' margin='normal'>
                  <LocalidadAutocomplete
                    key={keyComponentLocalidad}
                    onSelectLocalidad={handlerSelectLocalidad}
                  />
                </FormControl>
              </CardContent>
              <CardActions sx={{ justifyContent: 'flex-end', p: 2 }}>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={{ xs: 1, sm: 2 }}
                  justifyContent={{ xs: 'center', sm: 'flex-end' }}
                  alignItems={{ xs: 'strech' }}
                >
                  <Button
                    variant='contained'
                    size='medium'
                    startIcon={<HighlightOff />}
                    color='neutral'
                    onClick={handlerLimpiar}
                  >
                    Limpiar
                  </Button>
                  <LoadingButton
                    fullWidth={true}
                    type='submit'
                    variant='contained'
                    color='primary'
                    loading={loading ? 'show' : 'hide'}
                    content={'Buscar'}
                    startIcon={<Search />}
                    onClick={handleSubmit(find)}
                  />
                </Stack>
              </CardActions>
            </form>
          )}

          {!visibleFind && (
            <Grid container direction='column' justifyContent='space-between' spacing={1}>
              <Grid item>
                <div style={{ height: '50vh', width: '100%' }}>
                  <DataGrid
                    sx={{
                      border: 0,
                      '& .MuiDataGrid-cell': {
                        py: '8px',
                      },
                    }}
                    loading={!farmacias.length}
                    rows={farmacias.map((a) => mapFarmaciaToRow(a))}
                    columns={columns}
                    getRowHeight={() => 'auto'}
                    getEstimatedRowHeight={() => 200}
                    columnVisibilityModel={{
                      desplegable: screenWidth === 'xs',
                      id: false,
                      nombre: screenWidth !== 'xs',
                      localidad: screenWidth !== 'xs',
                      direccion: screenWidth !== 'xs',
                      mail: screenWidth !== 'xs',
                      telefono: screenWidth !== 'xs',
                    }}
                    pagination
                    autoPageSize
                    disableColumnMenu
                  />
                </div>
              </Grid>
              {visibleInfo ? (
                <Grid item>
                  <Alert severity='info'>
                    Sólo se muestran los primeros 50 resultados, agregue más criterios de búsqueda.
                  </Alert>
                </Grid>
              ) : null}
              <Grid item>
                <Grid container justifyContent='flex-end' spacing={1}>
                  <Grid item>
                    {' '}
                    <Button
                      variant='contained'
                      color='neutral'
                      startIcon={<Search />}
                      onClick={() => handleBuscarOtra()}
                    >
                      Buscar Otra
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Card>
      </Grid>
      <CustomizedSnackbars
        open={alertResultFind}
        severity='info'
        message={alertResultFind}
        onDeleteMessage={handleBorrarMensaje}
      />
      <CustomizedSnackbars
        open={error}
        severity='error'
        message={error}
        onDeleteMessage={handleBorrarMensaje}
      />
    </Grid>
  );
};

export default BuscarFarmacias;
